// src/lib/loaClient.js
export async function fetchLoaSummary(name) {
  // const res = await fetch(`/api/loa/summary?name=${encodeURIComponent(name)}`, { cache: "no-store" });
  const res = await fetch(`/api/loa/summary?name=${encodeURIComponent(name)}`, { cache: "no-store" });
  if (!res.ok) throw new Error(await res.text());
  return res.json(); // { className, engraving, combatPower, combatPowerText, itemAvgLevel, itemAvgLevelText }
}
